import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private __authService: AuthService,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let authotizationStarted = localStorage.getItem('authotizationStarted') == 'true';
    const token_one = localStorage.getItem('token_one')!;
    if (this.__authService.isLoggedIn() || token_one) {
      return true;//this.getAccessModule(state.url.split('#')[0]);
    }
    if (!authotizationStarted) {
      localStorage.clear();
      this.__authService.startAuthentication();
    }
    return false;
  }

  /*getAccessModule(url: string): boolean {
    this.accesos = JSON.parse(localStorage.getItem('accesos_app')!);
    this.acceso = [];
    switch (url) {
      case '/home': {
        return true;
      }
      case '/bsa': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_bsa');
        break;
      }
      case '/bsa-release': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_pre_billing');
        break;
      }
      case '/tax-exceptions': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_tax_excp');
        break;
      }
      case '/avalara': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_avalara_mapping');
        break;
      }
      case '/markup-exceptions': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_markup_exception');
        break;
      }
      case '/markup-rate': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_markup_rate');
        break;
      }
      case '/property-owner-mapping': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_owner_company_mapping');
        break;
      }
      case '/profit-center-maintenance': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_profit_center');
        break;
      }
      case '/employee-center-asociation': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_employee_profit');
        break;
      }
      case '/intercompany-maintenance': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_intercompany');
        break;
      }
      case '/sbu-orgcode-mapp': {
        this.acceso = this.accesos.filter(x => x.OPTION_KEY === 'menu_salesforce_bu_orgcodes');
        break;
      }
    }
    if (this.acceso.length > 0) {
      return true
    } else {
      return false;
    }
  }*/
}
